import { Outlet } from 'react-router-dom';
import { pagesConfig } from '../../../shared/pages-config';
import { useRouteMatch } from '../../../shared/useRouteMatch';
import RulesEngineGrid from './rules-engine-grid';
import SimpleBreadcrumbsPage from '../../../shared/simple-breadcrumbs-page';
import { ModuleList } from '../../../shared/analytics/module-list';

export default function RulesEnginePage() {
  const isFormPage = useRouteMatch([
    `${pagesConfig.rulesEngine.link}/${pagesConfig.createRule.link}`,
    `${pagesConfig.rulesEngine.link}/${pagesConfig.browseTemplates.link}`,
    `${pagesConfig.rulesEngine.link}/${pagesConfig.cloneRule.link}/:id`,
    `${pagesConfig.rulesEngine.link}/${pagesConfig.editRule.link}/:id`,
  ]);

  if (isFormPage) return <Outlet />;

  return (
    <SimpleBreadcrumbsPage
      bookmarkKey={pagesConfig.rulesEngine.value}
      breadcrumbs={[
        { label: ModuleList.modules.automation.name },
        { label: pagesConfig.rulesEngine.name },
      ]}
    >
      <RulesEngineGrid />
    </SimpleBreadcrumbsPage>
  );
}
